// extracted by mini-css-extract-plugin
export default {"warningIcon":"warningIcon__J6E4V","keyIcon":"keyIcon__ZqphV","button":"button__BGn2q"};